import React from "react"
import { FormattedMessage } from "react-intl";

export const STEP_1_INFO = {
  subtitle: (
    <FormattedMessage
      id="ProjectStepForm.step0.subtitle"
      defaultMessage="¡Bienvenido al sistema de la Biblioteca de Proyectos!"
    />
  ),
  additionalInfo: (
    <FormattedMessage
      id="ProjectStepForm.step0.additionalInfo"
      defaultMessage="Diligenciando el siguiente formulario, podrás cargar el tuyo."
    />
  ),
  description: (
    <FormattedMessage
      id="ProjectStepForm.step0.description"
      defaultMessage="El proyecto estará sujeto a aprobación del área de Mercadeo del negocio y de Mercadeo Central."
    />
  ),
};